import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/common/ErrorHandlerWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/common/LiveChatWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/common/PreloadStylesheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["THEME_STORAGE_KEY"] */ "/vercel/path0/apps/web/components/ui/adapters/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/design-system/themes/variables.css");
